var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4248 3.875V5H7.1748V3.875C7.1748 2.83906 6.33574 2 5.2998 2C4.26387 2 3.4248 2.83906 3.4248 3.875ZM1.9248 5V3.875C1.9248 2.01172 3.43652 0.5 5.2998 0.5C7.16308 0.5 8.6748 2.01172 8.6748 3.875V5H9.0498C9.87715 5 10.5498 5.67266 10.5498 6.5V11C10.5498 11.8273 9.87715 12.5 9.0498 12.5H1.5498C0.722461 12.5 0.0498047 11.8273 0.0498047 11V6.5C0.0498047 5.67266 0.722461 5 1.5498 5H1.9248Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure_icon.ab8856f8b8aedb42b33fb7d1fa128633.svg";
export { ForwardRef as ReactComponent };